// extracted by mini-css-extract-plugin
export default {"registration":"Registration_registration__P0EEM","form":"Registration_form__lrGKh","code":"Registration_code__xeR7z","done":"Registration_done__53Qf-"};